export class RecommendBadgeIconsRender {
    public static recommendBadgeIconsTemplate = `
        <i class="bi bi-bookmark-fill recommend-badge__icon" aria-hidden="true"></i>
    `;
}
